import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

import { FeatureTypes } from '../../../../../../constants/featureTypes';
import { getTabSelectOptions } from '../../../../../../constants/tabMenuTypes';
import { selectCompanyFeatures } from '../../../../../../redux/modules/company';
import { useCompanyQuestionCategories } from '../../../../../../services/company-service';
import RequirementTemplateBlueprintType from '../../../../../../types/RequirementTemplateBlueprintType';
import { HorizontalTabs, HTab } from '../../../../../HorizontalTabs';
import { horizontalTabContentBoxStyles } from '../../../../util/options';

const RequirementTemplateBuilderBodyRight = ({ blueprint }) => {
  const { companyId } = useParams();
  const currentTabIdRight = useSelector(blueprint.selectDefaultTemplateTabIdRight);
  const tabTypeOption = useSelector(blueprint.selectRightTabTypeOption);
  const horizontalTabs = getTabSelectOptions(tabTypeOption);
  const sidePanelHeight = useSelector(blueprint.selectSidePanelHeight);
  const { id: requirementTemplateId } = useSelector(blueprint.selectCurrentRequirementTemplate);
  const dispatch = useDispatch();

  const companyFeatures = useSelector(selectCompanyFeatures);

  const aiScanEnabled = useMemo(() => companyFeatures.find(f => [
    FeatureTypes.AiTierOne,
    FeatureTypes.AiTierTwo,
    FeatureTypes.AiTierThree
  ].includes(f.name))?.isEnabled, [companyFeatures]);

  useCompanyQuestionCategories({ companyId, requirementTemplateId, searchTerm: '', withDeleted: false });

  useEffect(() => {
    dispatch(blueprint.listInsuranceLanguages());
  }, []);

  return (
    <Flex
      align="center"
      h="93%"
      justifyContent="flex-start"
      minH="75vh"
      minW="380px"
      mt={5}
      w="380px"
    >
      {horizontalTabs && (
        <HorizontalTabs
          aiEnabled={aiScanEnabled}
          center={false}
          contentBoxStyles={{
            ...horizontalTabContentBoxStyles,
            height: sidePanelHeight
          }}
          defaultTabId={currentTabIdRight}
          paddingLeft="45px"
          specificTabGroupProps={{
            '.horizontal-tab.active': { width: '100px' },
            '.horizontal-tab.icon.active': { width: '130px' },
            '.horizontal-tab': { width: '65px' },
            '.horizontal-tab.icon': { width: '90px' },
            '.horizontal-tab.icon.active:after,.horizontal-tab.icon.active:before,.horizontal-tab.icon.active': { 'background-color': aiScanEnabled ? 'white' : '#000000' }
          }}
          tabGroupWidth="380px"
          tabMarginRight="20px"
          tabWidth="75px"
        >
          {horizontalTabs.map(option => (
            <HTab {...option} key={option.tabId} />
          ))}
        </HorizontalTabs>
      )}
    </Flex>
  );
};

RequirementTemplateBuilderBodyRight.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateBuilderBodyRight;
